<template>
    <div>
        <div class="cover-layer"></div>
        <div class="room-count" ref="roomCount">
                <ul>
                    <li @click="RoomCount(1)">1间</li>
                    <li @click="RoomCount(2)">2间</li>
                    <li @click="RoomCount(3)">3间</li>
                    <li @click="RoomCount(4)">4间</li>
                    <li @click="RoomCount(5)">5间</li>
                    <li @click="RoomCount(6)">6间</li>
                    <li @click="RoomCount(7)">7间</li>
                    <li @click="RoomCount(8)">8间</li>
                </ul>
            </div>
    </div>
</template>

<script>
    export default {
        name: "roomCount",
        props:{
            isRoomCountShow:{
                type:Boolean,
                default:false,
            },
        },
        data: function () {
            return {}
        },

        mounted() {
            this.addCloseListener();
        },
        methods: {
            RoomCount(val){
                this.$emit('select',val);
            },
            addCloseListener() {
                let that = this;
                document.addEventListener('click', that.onClick,false);
            },
            onClick(e){
                if (e.target.className == 'room-count' || this.$refs.roomCount && this.$refs.roomCount.contains(e.target)) return;
                this.$emit('select')
            }
        },
        destroyed(){
            document.removeEventListener('click', this.onClick,false)
        },
    }
</script>

<style scoped>
    .room-count{
        position: absolute;
        top: 49px;
        left: -1px;
        width: 119px;
        border: 1px solid #e6e6e6;
        background: #FFF;
        z-index: 2;
    }
    .room-count ul li{
        padding: 0px 10px;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
    }
    .room-count ul li:hover{
        color: #fff;
        background: #00a0e9;
    }
</style>


// WEBPACK FOOTER //
// src/common/cmpnt/roomCount/roomCount.vue